import { TaskInfo } from '@dispatch/shared/types';
import React from 'react';

export const useResourceDataGrid = () => {
  const [showOnlyQualified, setShowOnlyQualified] =
    React.useState<boolean>(true);
  const [resourcesFilters, setResourceFilters] = React.useState({
    pageSize: 10,
  });
  const [taskToAssign, setTaskToAssign] = React.useState<TaskInfo>();
  const [modalState, setModalState] = React.useState({ open: false });

  return {
    showOnlyQualified,
    setShowOnlyQualified,
    resourcesFilters,
    setResourceFilters,
    taskToAssign,
    setTaskToAssign,
    modalState,
    setModalState,
  };
};
